import React from 'react';
import { DayPicker } from 'react-day-picker';
import { es } from 'date-fns/locale';
import 'react-day-picker/style.css';

/**
 * DateRangePicker — Selector visual de rango (from, to).
 *
 * Uso:
 *   <DateRangePicker
 *     from={from} to={to}
 *     onChange={({from, to}) => ...}
 *   />
 */
export const DateRangePicker = ({ from, to, onChange }) => {
    const handleSelect = (range) => {
        if (!range) {
            onChange?.({ from: null, to: null });
            return;
        }
        onChange?.({ from: range.from || null, to: range.to || null });
    };

    return (
        <DayPicker
            mode="range"
            locale={es}
            selected={{ from: from || undefined, to: to || undefined }}
            onSelect={handleSelect}
            numberOfMonths={1}
            weekStartsOn={1}
            modifiersStyles={{
                selected: {
                    backgroundColor: '#0066b3',
                    color: 'white',
                },
                range_middle: {
                    backgroundColor: 'rgba(0, 102, 179, 0.12)',
                    color: '#003c66',
                },
                range_start: {
                    backgroundColor: '#0066b3',
                    color: 'white',
                },
                range_end: {
                    backgroundColor: '#0066b3',
                    color: 'white',
                },
                today: {
                    fontWeight: 700,
                    color: '#0066b3',
                },
            }}
        />
    );
};
